/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statswithevent2Inputs */

const en_statswithevent2 = /** @type {(inputs: Statswithevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With an event`)
};

const de_statswithevent2 = /** @type {(inputs: Statswithevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Event`)
};

/**
* | output |
* | --- |
* | "With an event" |
*
* @param {Statswithevent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statswithevent2 = /** @type {((inputs?: Statswithevent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statswithevent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statswithevent2(inputs)
	return de_statswithevent2(inputs)
});
export { statswithevent2 as "statsWithEvent" }